import { Layout as AntdLayout } from 'antd';
import type React from 'react';
import { Header } from 'src/components/layout/header/header';
import { Sidebar } from 'src/components/layout/sidebar/sidebar';
import { useIsUserLoggedIn } from 'src/hooks/data/users';
import { AuthLayout } from './auth-layout/auth-layout';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isUserLoggedIn = useIsUserLoggedIn();

  if (!isUserLoggedIn) {
    return <AuthLayout>{children}</AuthLayout>;
  }

  return (
    <AntdLayout className="min-h-screen min-w-[1280px]">
      <Header />

      <AntdLayout>
        <Sidebar />

        <AntdLayout.Content className="pb-18 px-24">{children}</AntdLayout.Content>
      </AntdLayout>
    </AntdLayout>
  );
};
